import 'bootstrap-3-typeahead'
